module.exports = __webpack_public_path__ + "static/img/image_solutions_servo_01.2ef0b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_servo_01.png
// module id = 4biT
// module chunks = 10